<template>
  <div class="relative">
    <div class="min-h-screen w-full">
      <DefaultHeader />
      <RouterView />
    </div>
  </div>
</template>

<script setup lang="ts">
import DefaultHeader from '@/core/components/common/DefaultHeader.vue';
</script>

<style lang="scss" scoped></style>
